import { useLazyQuery } from '@apollo/client';
import Icone from 'components/Icone';
import ListTemplate from 'components/template/ListTemplate';
import { GRAPHQL_BUSCAR_USUARIO_LOG_DETALHE } from 'gql/usuarioLog';
import React, { FC, useCallback, useMemo, useState } from 'react';
import { useHeaderUsuarioLogs } from './hooks/useHeaderUsuarioLogs';
import { useQueryFilterUsuarioLogs } from './hooks/useQueryFilterUsuarioLogs';
import {
    IQueryUsuarioLogDetalhe,
    IUsuarioLog,
} from './hooks/useQueryFilterUsuarioLogs/index.d';
import { useTransformUsuarioLogs } from './hooks/useTransformUsuarioLogs';
import {
    DetailItem,
    JsonBlock,
    ModalContainer,
    ModalContent,
    ModalHeader,
    ModalOverlay,
} from './styl';

const formatJson = (value?: string) => {
    if (!value) {
        return '-';
    }

    try {
        return JSON.stringify(JSON.parse(value), null, 2);
    } catch (error) {
        return value;
    }
};

const PageListUsuarioLogs: FC = () => {
    const props = useQueryFilterUsuarioLogs();
    const colunas = useHeaderUsuarioLogs();
    const [selectedLogId, setSelectedLogId] = useState<string | null>(null);

    const [buscarDetalhe, { data: detalheData, loading: detalheLoading }] =
        useLazyQuery<IQueryUsuarioLogDetalhe>(GRAPHQL_BUSCAR_USUARIO_LOG_DETALHE, {
            fetchPolicy: 'no-cache',
        });

    const handleViewDetails = useCallback(
        (log: IUsuarioLog) => {
            setSelectedLogId(log.id);
            buscarDetalhe({ variables: { id: log.id } });
        },
        [buscarDetalhe],
    );

    const data = useTransformUsuarioLogs(props.response || [], handleViewDetails);

    const logDetalhe = useMemo(() => {
        return detalheData?.usuarioLogById || null;
    }, [detalheData]);

    const handleCloseModal = useCallback(() => {
        setSelectedLogId(null);
    }, []);

    return (
        <>
            <ListTemplate
                browserTitle="Logs de Usuário"
                colunas={colunas}
                data={data}
                {...props}
            />

            {selectedLogId && (
                <ModalOverlay onClick={handleCloseModal}>
                    <ModalContainer onClick={event => event.stopPropagation()}>
                        <ModalHeader>
                            <h2>Detalhes do Log</h2>
                            <button onClick={handleCloseModal}>
                                <Icone
                                    icone="icon-fechar"
                                    size="2rem"
                                    color="var(--btn-admin-icone)"
                                />
                            </button>
                        </ModalHeader>
                        <ModalContent>
                            {detalheLoading && <p>Carregando detalhes...</p>}

                            {!detalheLoading && !logDetalhe && (
                                <p>Nenhum detalhe encontrado para este log.</p>
                            )}

                            {!detalheLoading && logDetalhe && (
                                <>
                                    <DetailItem>
                                        <strong>Usuário</strong>
                                        <span>
                                            {logDetalhe.usuarioNomeCompleto || '-'} (
                                            {logDetalhe.usuarioEmail ||
                                                logDetalhe.usuarioId ||
                                                '-'})
                                        </span>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>Ação</strong>
                                        <span>{logDetalhe.acao || '-'}</span>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>Descrição</strong>
                                        <span>{logDetalhe.descricao || '-'}</span>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>Rota / Método</strong>
                                        <span>
                                            {logDetalhe.rota || '-'} /{' '}
                                            {logDetalhe.metodo || '-'}
                                        </span>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>Status / Tempo (ms)</strong>
                                        <span>
                                            {logDetalhe.status || '-'} /{' '}
                                            {logDetalhe.tempoExecucaoMs ?? '-'}
                                        </span>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>IP Address</strong>
                                        <span>{logDetalhe.ipAddress || '-'}</span>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>User Agent</strong>
                                        <span>{logDetalhe.userAgent || '-'}</span>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>Erro</strong>
                                        <span>{logDetalhe.erroMensagem || '-'}</span>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>Parâmetros (JSON)</strong>
                                        <JsonBlock>
                                            {formatJson(logDetalhe.parametros)}
                                        </JsonBlock>
                                    </DetailItem>
                                    <DetailItem>
                                        <strong>Resultados (JSON)</strong>
                                        <JsonBlock>
                                            {formatJson(logDetalhe.resultados)}
                                        </JsonBlock>
                                    </DetailItem>
                                </>
                            )}
                        </ModalContent>
                    </ModalContainer>
                </ModalOverlay>
            )}
        </>
    );
};

export default PageListUsuarioLogs;
